<template>
  <footer :style="isHome?'':'height:8px'" class="ksm-footer ksm-disable-select">
    <div class="ksm-footer__main">
      <template v-for="(it, i) in footItemsLeft">
        <router-link
          style="height:100%; margin-right:25px; padding:0"
          v-if="!it.img && !it.png"
          :to="it.url"
          :key="'r'+i"
          class="ksm-flex-xy-center ksm-link-text"
        >{{it.label}}</router-link>
        <a
          v-else
          :href="it.url"
          target="_blank"
          :key="'m'+i"
          class="ksm-flex-xy-center ksm-link-img"
          style="height:100%; margin-right:25px; padding:0"
        >
          <div class="ksm-flex-xy-center">
            <div :style="it.style" v-if="it.img" v-html="$_getSvg(it.img)"></div>
            <div :style="it.style" v-if="it.png">
              <img style="height:100%" :src="$_getIcon(it.png)" />
            </div>
          </div>
        </a>
      </template>
      <div class="ksm-flex-1"></div>
      <div class="ksm-flex-00auto ksm-flex">
        <template v-for="(it, j) in footItemsRight">
          <div :key="'s'+j" class="ksm-flex-xy-center" v-if="j>0">|</div>
          <router-link
            :key="'b'+j"
            class="ksm-link-text ksm-flex-xy-center"
            :to="it.url"
          >{{it.label}}</router-link>
        </template>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      logoItems: [
        {
          png: "uni-wuppertal_logo_grau.png",
          title: "Uni Wuppertal",
          url: "https://www.uni-wuppertal.de/",
          style: "height:45px; width:120px"
        },
        {
          png: "SMH_Logo_SCHWARZ.jpg",
          title: "Sprengel Museum",
          url: "http://www.sprengel-museum.de/",
          style: "height:48px; width:20px"
        },
        {
          img: "kompetenz_logo_2016_neg.svg",
          title: "Kompetenzzentrum",
          url: "http://kompetenzzentrum.uni-trier.de/de/",
          style: "height:100%; width:180px; margin-right:-15px"
        },
        {
          img: "Logo_Uni_Trier_typo_neg.svg",
          title: "Uni Trier",
          url: "http://www.uni-trier.de",
          style:
            "height:100%; width:160px;padding-bottom:5px; margin-right:-15px"
        },
        {
          png: "dfg_logo_schriftzug_blau_foerderung_4c.jpg",
          title: "Uni Trier",
          url: "http://www.dfg.de",
          style: "height:45px; width:140px"
        }
      ],
      footNavItems: [
        {
          url: "/projektinfo",
          label: "Projektinfo"
        },
        {
          url: "/beteiligte",
          label: "Beteiligte"
        },
        {
          url: "/foerderer",
          label: "Förderer"
        },
        {
          url: "/kontakt",
          label: "Kontakt"
        },
        {
          url: "/datenschutz",
          label: "Datenschutz"
        },
        {
          url: "/impressum",
          label: "Impressum"
        }
      ]
    };
  },
  computed: {
    showFooter() {},
    isHome() {
      return this.$route.name == "home";
    },
    footItemsLeft() {
      let out = [this.footNavItems[0]];
      out = out.concat(this.logoItems);
      return out;
    },
    footItemsRight() {
      return this.footNavItems.filter((a, i) => i > 0);
    }
  },
  methods: {}
};
</script>
<style lang="scss">
.ksm-footer {
  @extend .ksm-flex;
  &:hover {
    height: 60px !important;
    transition-delay: 0.5s;
  }
  transition: height 0.3s;
  transition-delay: 0;
  z-index: 100;
  position: absolute;
  width: 100%;
  bottom: 0px;
  left: 0px;
  overflow: hidden;
  background-color: rgb(45, 46, 48);
}

.ksm-footer__main {
  height: 60px;
  @extend .ksm-flex-1;
  @extend .ksm-flex;
  padding-left: 30px;
  padding-right: 10px;

  * {
    margin-right: 10px;
    font-size: 12px;
    color: grey;
  }
  svg {
    * {
      fill: grey;
    }
  }
  img {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }
}
</style>


// WEBPACK FOOTER //
// Footer.vue?06b14016